var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg129(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612.05 572.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffb600;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.56,108.39c4.44-1,11.37,5.32,15.61,7.58,37.26,19.89,82.7,24.77,124.46,22.37,5.31-.3,14.17-2.46,18.93-2.04,3.77.34,5.78,4.03,5.7,7.52-1.28,40.86,1.61,82.66,0,123.41-3.62,92-58.46,157.57-143.56,187.59-4.25,1.5-15.3,5.77-19.13,5.9-3.12.11-13.98-3.91-17.61-5.16-86.23-29.79-142.21-95.08-145.77-188.32-1.56-40.78,1.26-82.54,0-123.42-.06-11.95,16.75-5.94,24.63-5.49,42.74,2.45,87.89-2.47,125.93-23.11,2.45-1.33,9.19-6.49,10.79-6.85ZM287.54,180.42c-70.37,5.76-111.8,84.46-78.8,146.65,34.71,65.42,126.59,71.48,169.86,11.23,50.33-70.09-5.6-164.87-91.06-157.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.93,254.36h26.07c4.21,0,8.1,4.28,8.48,8.41,1.05,11.38-.82,24.4-.08,35.97-.03,2.72-5.41,7.02-7.67,7.02h-26.8v26.8c0,3.67-4.81,7.41-8.41,7.74-11.38,1.05-24.4-.82-35.97-.08-2.72-.03-7.02-5.41-7.02-7.67v-26.8h-26.8c-2.26,0-7.64-4.29-7.67-7.02.74-11.57-1.13-24.59-.08-35.97.38-4.13,4.27-8.41,8.48-8.41h26.07v-26.8c0-2.91,4.19-7,7.15-7.54,4.48-.81,33.74-.85,37.66.17,2.59.67,6.59,4.75,6.59,7.36v26.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg129);
export default __webpack_public_path__ + "static/media/1-29.d8f5bcc978e7b7a85be0592ade564b91.svg";
export { ForwardRef as ReactComponent };